import axios from 'axios'
import { AUTH_HEADERS, AUTH_HEADERS_BLOB } from '../utils/config'
export default {
  getAll (limit, offset) {
    return axios.get(`${process.env.VUE_APP_BASE_URL}changeOrderDocument/all?limit=${limit}&offset=${offset}`, AUTH_HEADERS())
  },
  getUrl (id) {
    return axios.get(`${process.env.VUE_APP_BASE_URL}changeOrderDocument/url/${id}`, AUTH_HEADERS())
  },
  getFile (id) {
    return axios.get(`${process.env.VUE_APP_BASE_URL}changeOrderDocument/file/${id}`, AUTH_HEADERS_BLOB())
  },
  getByChangeOrder (changeOrderId) {
    return axios.get(`${process.env.VUE_APP_BASE_URL}changeOrderDocument/changeOrder/${changeOrderId}`, AUTH_HEADERS())
  },
  uploadCreate (object) {
    let formData = new FormData()
    formData.append('file', object.file)
    return axios.post(`${process.env.VUE_APP_BASE_URL}changeOrderDocument/createUpload?changeOrderId=${object.changeOrderId}&userId=${object.userId}&status=${object.status}`, formData, AUTH_HEADERS())
  },
  update (document) {
    return axios.put(`${process.env.VUE_APP_BASE_URL}changeOrderDocument/update`, document, AUTH_HEADERS())
  },
  delete (id) {
    return axios.delete(`${process.env.VUE_APP_BASE_URL}changeOrderDocument/remove/${id}`, AUTH_HEADERS())
  }
}// There is also seperate create & upload controllers, when versioning is added Upload can be used.
